import React from 'react';
import { Stack } from '@moda/om';
import { SECONDS_TO_MILLISECONDS, useTimer } from '@moda/portal-stanchions';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import {
  TrunkshowCountdownTimer,
  SHOW_TIMER_UPPER_BOUND_IN_DAYS
} from '../../TrunkshowCountdownTimer';
import { LineItemType } from '../lineItemMutations.rest';
import { LineItemMiniGranularity } from '../LineItemMini';
import { LineItemSoldOutNote } from './LineItemSoldOutNote';

import './LineItemAvailabilityNotes.scss';

type Props = {
  granularity?: LineItemMiniGranularity;
  item: LineItem;
  onChangeType?: (type: LineItemType) => void;
};

export const LineItemAvailabilityNotes: React.FC<Props> = ({
  granularity,
  item: {
    type,
    attributes: { isProductAvailable, isTrunkshow, activeEndAt }
  },
  onChangeType
}) => {
  const [timeLeft] = useTimer((activeEndAt || Infinity) * SECONDS_TO_MILLISECONDS);

  const showTrunkshowExpiredNote = type === 'cart_items' && !isProductAvailable && isTrunkshow;
  const showSoldOutNote = type === 'cart_items' && !isProductAvailable && !isTrunkshow;
  const showTrunkshowTimer =
    isProductAvailable && isTrunkshow && Number(timeLeft.daysLeft) < SHOW_TIMER_UPPER_BOUND_IN_DAYS;

  if (!showTrunkshowExpiredNote && !showSoldOutNote && !showTrunkshowTimer) return null;

  return (
    <Stack className="LineItemAvailabilityNotes" space={1} direction="horizontal">
      {showTrunkshowExpiredNote && (
        <LineItemSoldOutNote
          granularity={granularity}
          message="Trunkshow has ended."
          onSaveForLater={() => onChangeType && onChangeType('SavedItem')}
        />
      )}

      {showSoldOutNote && (
        <LineItemSoldOutNote
          granularity={granularity}
          message="This item is no longer available."
          onSaveForLater={() => onChangeType && onChangeType('SavedItem')}
        />
      )}

      {showTrunkshowTimer && typeof activeEndAt === 'number' && (
        <TrunkshowCountdownTimer
          className="LineItemAvailabilityNotes__timer"
          endingText="Trunkshow ends in "
          countdownTime={activeEndAt}
          hasZeroes={false}
          hasIcon
        />
      )}
    </Stack>
  );
};
